// 受众数据来源类型
const AudienceViewSource = {
  NONE: 'none', // 没有受众数据
  FIRST_PARTY: 'first_party', //一方平台数据
  SELF_ESTIMATED: 'self_estimated' // 自研数据
};

// 自研数据状态
const SelfEstimatedStatus = {
  SUCCESS: 'success', // 成功
  PENDING: 'pending', // 待处理   要轮询受众信息
  PROCESSING: 'processing', // 处理中  要轮询受众信息
  FAILED: 'failed' // 失败
};

// 没有数据时的情况
const NoneSource = {
  NOT_STARTED: 'not_started', // 展示触发入口；用户点击后调用：
  UNSUPPORTED: 'unsupported', // 不展示自研触发入口
  INSUFFICIENT_AUDIENCE: 'insufficient_audience' // 停止 loading，提示样本不足；不阻塞申请
};

// 状态判断：一手数据 或者自研数据success状态，才算是有数据。  判断如下
//  source === AudienceViewSource.FIRST_PARTY
// || (source === AudienceViewSource.SELF_ESTIMATED && status === SelfEstimatedStatus.SUCCESS)

// 状态参考： https://cxa8mlnnp7j.feishu.cn/docx/GmN3djzdCoC9EmxL9ZmcbmlKngh

export { AudienceViewSource, SelfEstimatedStatus, NoneSource };
